import { MutableRefObject } from 'react';
import { Division } from '@la/types';
import { DivisionDisplay } from '../DivisionDisplay/DivisionDisplay';
import { DivisionsModal } from '../DivisionsModal/DivisionsModal';
import * as S from './DivisionsDisplay.styles';

export type DivisionsDisplayProps = {
  addRef: (
    divisionId: string,
    ref: MutableRefObject<HTMLElement | null>
  ) => void;
  divisions: Division[];
  refs: Map<string, MutableRefObject<HTMLElement | null>>;
  subProgramLabel: string;
};

export function DivisionsDisplay({
  addRef,
  divisions,
  refs,
  subProgramLabel,
}: DivisionsDisplayProps) {
  return (
    <S.Container>
      <S.Header>Participating teams</S.Header>
      <S.ModalButtonContainer>
        <DivisionsModal
          divisions={divisions}
          refs={refs}
          subProgramLabel={subProgramLabel}
        />
      </S.ModalButtonContainer>
      {divisions.map((division) => (
        <DivisionDisplay
          addRef={addRef}
          division={division}
          key={`participants-${division.subProgramLabel}-${division.id}`}
        />
      ))}
    </S.Container>
  );
}
